import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { HiMicrophone, HiEye, HiEyeOff } from "react-icons/hi";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";
const API = `${API_BASE}/api/auth`;

export default function LoginPage() {
  const { login, signup } = useAuth();
  const [tab,      setTab]     = useState("login"); // login | signup | forgot
  const [name,     setName]    = useState("");
  const [email,    setEmail]   = useState("");
  const [pass,     setPass]    = useState("");
  const [newPass,  setNewPass] = useState("");
  const [otp,      setOtp]     = useState("");
  const [showP,    setShowP]   = useState(false);
  const [error,    setError]   = useState("");
  const [success,  setSuccess] = useState("");
  const [loading,  setLoad]    = useState(false);
  const [otpSent,  setOtpSent] = useState(false);

  const reset = () => { setError(""); setSuccess(""); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    reset();
    if (!email.trim() || !pass.trim()) { setError("Please fill all fields."); return; }
    if (tab === "signup" && !name.trim()) { setError("Please enter your name."); return; }
    if (pass.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoad(true);
    try {
      const result = tab === "signup"
        ? await signup(name.trim(), email.trim(), pass)
        : await login(email.trim(), pass);
      if (result && result.error) setError(result.error);
    } catch (err) {
      setError("Cannot connect to authorization server. Please ensure the backend is running.");
    } finally {
      setLoad(false);
    }
  };

  const sendOtp = async (e) => {
    e.preventDefault();
    reset();
    if (!email.trim()) { setError("Enter your email first."); return; }
    setLoad(true);
    try {
      const r = await fetch(`${API}/send-otp`, { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ email }) });
      const d = await r.json();
      if (!r.ok) { setError(d.error || "Failed to send OTP."); }
      else { setOtpSent(true); setSuccess(d.message || "OTP sent!"); if (d.otp) setSuccess(`Dev mode OTP: ${d.otp}`); }
    } catch { setError("Cannot connect to server."); }
    setLoad(false);
  };

  const resetPass = async (e) => {
    e.preventDefault();
    reset();
    if (!otp || !newPass) { setError("Enter OTP and new password."); return; }
    if (newPass.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoad(true);
    try {
      const r = await fetch(`${API}/reset-password`, { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ email, otp, newPassword: newPass }) });
      const d = await r.json();
      if (!r.ok) { setError(d.error || "Reset failed."); }
      else { setSuccess("Password reset! You can now sign in."); setTimeout(() => { setTab("login"); setOtpSent(false); setOtp(""); setNewPass(""); reset(); }, 2000); }
    } catch { setError("Cannot connect to server."); }
    setLoad(false);
  };

  const inp = { width:"100%", background:"#18181f", border:"1px solid rgba(255,255,255,0.08)", borderRadius:8, color:"#f5f5f7", fontSize:14, padding:"11px 13px", outline:"none", boxSizing:"border-box", transition:".15s", fontFamily:"inherit" };

  return (
    <div style={{minHeight:"100vh",background:"#09090b",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"'Inter',sans-serif",padding:24,position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",top:0,left:"50%",transform:"translateX(-50%)",width:600,height:480,background:"radial-gradient(ellipse at 50% 0%,rgba(124,58,237,0.15),transparent 62%)",pointerEvents:"none"}}/>

      <div style={{position:"relative",maxWidth:420,width:"100%"}}>
        {/* Logo */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10,marginBottom:32}}>
          <div style={{width:40,height:40,borderRadius:10,background:"linear-gradient(135deg,#7c3aed,#a855f7)",display:"flex",alignItems:"center",justifyContent:"center",boxShadow:"0 0 20px rgba(124,58,237,0.45)"}}>
            <HiMicrophone size={19} color="#fff"/>
          </div>
          <span style={{fontSize:20,fontWeight:800,letterSpacing:"-0.035em",color:"#f5f5f7"}}>VoiceForge</span>
        </div>

        {/* Card */}
        <div style={{background:"#111117",border:"1px solid rgba(255,255,255,0.08)",borderRadius:16,padding:"30px 26px",boxShadow:"0 20px 60px rgba(0,0,0,0.6)"}}>

          {/* Tabs */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:0,border:"1px solid rgba(255,255,255,0.08)",borderRadius:9,overflow:"hidden",marginBottom:24,background:"#18181f"}}>
            {[["login","Sign In"],["signup","Sign Up"]].map(([id,lbl])=>(
              <button key={id} onClick={()=>{setTab(id);reset();}} style={{padding:"10px",fontSize:13,fontWeight:600,background:tab===id?"rgba(124,58,237,0.15)":"transparent",color:tab===id?"#a78bfa":"#55556a",border:"none",cursor:"pointer",transition:".15s",fontFamily:"inherit"}}>
                {lbl}
              </button>
            ))}
          </div>

          {tab === "forgot" ? (
            // Forgot password flow
            <form onSubmit={otpSent ? resetPass : sendOtp} style={{display:"flex",flexDirection:"column",gap:12}}>
              <h3 style={{fontSize:16,fontWeight:700,color:"#f5f5f7",marginBottom:2}}>Reset Password</h3>
              <div>
                <label style={{fontSize:12,fontWeight:500,color:"#9090a8",display:"block",marginBottom:5}}>Email</label>
                <input style={inp} type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="your@email.com" required/>
              </div>
              {otpSent && <>
                <div>
                  <label style={{fontSize:12,fontWeight:500,color:"#9090a8",display:"block",marginBottom:5}}>OTP Code</label>
                  <input style={inp} type="text" value={otp} onChange={e=>setOtp(e.target.value)} placeholder="6-digit code from email" required maxLength={6}/>
                </div>
                <div>
                  <label style={{fontSize:12,fontWeight:500,color:"#9090a8",display:"block",marginBottom:5}}>New Password</label>
                  <input style={inp} type="password" value={newPass} onChange={e=>setNewPass(e.target.value)} placeholder="New password (min 6 chars)" required/>
                </div>
              </>}
              {error  && <div style={{background:"rgba(244,63,94,0.08)",border:"1px solid rgba(244,63,94,0.22)",borderRadius:7,padding:"9px 12px",fontSize:12,color:"#f43f5e"}}>{error}</div>}
              {success && <div style={{background:"rgba(52,211,153,0.08)",border:"1px solid rgba(52,211,153,0.22)",borderRadius:7,padding:"9px 12px",fontSize:12,color:"#34d399"}}>{success}</div>}
              <button type="submit" disabled={loading} style={{width:"100%",height:44,borderRadius:8,background:loading?"#1f1f28":"var(--p,#7c3aed)",color:loading?"#9090a8":"#fff",fontSize:13,fontWeight:600,border:"none",cursor:loading?"not-allowed":"pointer",fontFamily:"inherit"}}>
                {loading?"Please wait…":otpSent?"Reset Password":"Send OTP"}
              </button>
              <button type="button" onClick={()=>{setTab("login");reset();setOtpSent(false);}} style={{fontSize:12,color:"#55556a",background:"none",border:"none",cursor:"pointer",fontFamily:"inherit"}}>← Back to Sign In</button>
            </form>
          ) : (
            // Login / Signup
            <form onSubmit={handleSubmit} style={{display:"flex",flexDirection:"column",gap:12}}>
              {tab === "signup" && (
                <div>
                  <label style={{fontSize:12,fontWeight:500,color:"#9090a8",display:"block",marginBottom:5}}>Full Name</label>
                  <input style={inp} type="text" value={name} onChange={e=>setName(e.target.value)} placeholder="Your name" required/>
                </div>
              )}
              <div>
                <label style={{fontSize:12,fontWeight:500,color:"#9090a8",display:"block",marginBottom:5}}>Email</label>
                <input style={inp} type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="your@email.com" required/>
              </div>
              <div>
                <label style={{fontSize:12,fontWeight:500,color:"#9090a8",display:"block",marginBottom:5}}>Password</label>
                <div style={{position:"relative"}}>
                  <input style={{...inp,paddingRight:40}} type={showP?"text":"password"} value={pass} onChange={e=>setPass(e.target.value)} placeholder="Min. 6 characters" required/>
                  <button type="button" onClick={()=>setShowP(!showP)} style={{position:"absolute",right:11,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"#55556a",cursor:"pointer",display:"flex",alignItems:"center"}}>
                    {showP?<HiEyeOff size={16}/>:<HiEye size={16}/>}
                  </button>
                </div>
              </div>

              {error   && <div style={{background:"rgba(244,63,94,0.08)",border:"1px solid rgba(244,63,94,0.22)",borderRadius:7,padding:"9px 12px",fontSize:12,color:"#f43f5e"}}>{error}</div>}
              {success && <div style={{background:"rgba(52,211,153,0.08)",border:"1px solid rgba(52,211,153,0.22)",borderRadius:7,padding:"9px 12px",fontSize:12,color:"#34d399"}}>{success}</div>}

              <button type="submit" disabled={loading} style={{width:"100%",height:46,borderRadius:9,background:loading?"#1f1f28":"linear-gradient(135deg,#7c3aed,#9333ea)",color:loading?"#9090a8":"#fff",fontSize:14,fontWeight:600,border:"1px solid rgba(255,255,255,0.08)",cursor:loading?"not-allowed":"pointer",boxShadow:loading?"none":"0 0 22px rgba(124,58,237,0.35)",marginTop:2,fontFamily:"inherit"}}>
                {loading?"Please wait…":tab==="login"?"Sign In →":"Create Account →"}
              </button>

              {tab === "login" && (
                <button type="button" onClick={()=>{setTab("forgot");reset();}} style={{fontSize:12,color:"#55556a",background:"none",border:"none",cursor:"pointer",textAlign:"right",fontFamily:"inherit"}}>
                  Forgot password?
                </button>
              )}
            </form>
          )}
        </div>

        <p style={{marginTop:16,fontSize:11,color:"#3a3a55",textAlign:"center"}}>
          Built by <span style={{color:"#a78bfa",fontWeight:600}}>Fahad Ali Mazari</span> · Your data stays on your device
        </p>
      </div>
    </div>
  );
}
